'use strict'

function translateField(field,translation) {
  let fieldTranslation=translation!==undefined && translation.fields!==undefined ? translation.fields[field.name] : undefined;
  if (field.columns && fieldTranslation!==undefined && fieldTranslation.columns!==undefined) {
    var columns=field.columns.map(column=>Object.assign({},column,fieldTranslation.columns[column.name]));
    fieldTranslation=Object.assign({},fieldTranslation,{columns:columns});
  }
  if (field.columnHeaders && fieldTranslation!==undefined && fieldTranslation.columnHeaders!==undefined) {
    var columnHeaders=field.columnHeaders.map(columnHeader=>Object.assign({},columnHeader,fieldTranslation.columnHeaders[columnHeader.name]));
    fieldTranslation=Object.assign({},fieldTranslation,{columnHeaders:columnHeaders});
  }
  if ((field.type==="table" || field.type==="multiTable")) {
    if (fieldTranslation!==undefined && fieldTranslation.options!==undefined) {
      var options=Object.keys(field.options)
        .map(key=>({key:key, value:Object.assign({},field.options[key],fieldTranslation.options[key])}))
        .reduce((object,item)=>Object.assign({},object,{[item.key]:item.value}),{});
        fieldTranslation=Object.assign({},fieldTranslation,{options:options});
    } else {
      fieldTranslation=Object.assign({},fieldTranslation,{options:field.options});
    }
  } else if (field.options!==undefined && fieldTranslation!==undefined && fieldTranslation.options!==undefined) {
    var options=field.options.map(option=>Object.assign({},option,{text:fieldTranslation.options[option.value]}));
    fieldTranslation=Object.assign({},fieldTranslation,{options:options});
  }
  if (field.type==="matrix" && fieldTranslation!==undefined) {
    fieldTranslation=Object.assign({},fieldTranslation,{
      fields: field.fields.map(field=>translateField(field,fieldTranslation)),
      categories: field.categories.map(category=>Object.assign({},category,fieldTranslation.categories!==undefined ? fieldTranslation.categories[category.name] : undefined))
    });
  }
  return fieldTranslation!==undefined
    ? Object.assign({},field,fieldTranslation)
    : field;
}

function updateLabels(area,areaTranslation) {
  return Object.assign({},area,
    Object.assign({},areaTranslation, {
      fields: area.fields!==undefined ? area.fields.map(field=>translateField(field,areaTranslation)) : undefined
    }));
}

function isFormOrAreaNotDefined(form,key) {
  return form===undefined || form.filter(area=>area.name===key).length===0;
}

function hasFields(variable,key) {
  return (variable[key]!==undefined && variable[key].fields!==undefined);
}

function updateColumns(fieldForm,fieldTranslation,fieldVariant) {
var columnTranslations=fieldTranslation!==undefined && fieldTranslation.columns!==undefined ? fieldTranslation.columns : {};
  return Object.assign({},fieldVariant, {
   columns:fieldForm.columns===undefined ? undefined : fieldForm.columns
    .map(column=>({
      [column.name]: Object.assign({},
          fieldTranslation!==undefined && fieldTranslation.columns!==undefined
            ? fieldTranslation.columns[column.name]
            : undefined,
          fieldVariant.columns[column.name]
        )
      })
    )
    .reduce((object,field)=>Object.assign({},object,field))
  });
}

function mergedFieldVariant(fieldDetails,translation,variant) {
  let form=fieldDetails.form;
  let key=fieldDetails.key;
  let field=fieldDetails.field;

  var fieldVariant=variant[key].fields[field.name];
  var fieldTranslation=translation[key].fields[field.name];
  var fieldForm=form.filter(area=>area.name===key)[0].fields.filter(f=>f.name===field.name)[0];

  if (fieldVariant!==undefined && fieldVariant.columns!==undefined) {
    fieldVariant=updateColumns(fieldForm,fieldTranslation,fieldVariant);
  }

  return fieldVariant;
}

function mergeVariantFields(formDetails,translation,variant) {
  let form=formDetails.form;
  let key=formDetails.key;
  let fields=form.filter(area=>area.name===key)[0].fields
  return fields===undefined
    ? undefined
    : fields
    .map(field=>{
       if (hasFields(translation,key) && hasFields(variant,key)) {
         return {
           [field.name]: Object.assign({},
              translation[key].fields[field.name],
              mergedFieldVariant({form:form, key:key, field:field},translation,variant)
            )
          };
        } else if (hasFields(translation,key)) {
          return {
            [field.name]: translation[key].fields[field.name]
          };
        } else if (hasFields(variant,key)) {
          return {
            [field.name]: variant[key].fields[field.name]
          };
        } else {
          return undefined;
        }
      }
    )
    .reduce((object,field)=>Object.assign({},object,field));
}

/* Replaced by mergeVariant 2019-01-17
function mergeLabels(form,translation,variant) {
  var labels={};
  if (variant!==undefined) {
    var possibleTranslations=Object.keys(translation).concat(Object.keys(variant).concat(form!==undefined ? form.map(area=>area.name): undefined));
    [...new Set(possibleTranslations)]
    .forEach(key=>{
      if (isFormOrAreaNotDefined(form,key)) {
        labels[key]=variant[key];
      } else {
        let mergedVariant=Object.assign({},variant[key],{
          fields: mergeVariantFields({form:form, key:key },translation,variant)
        });
        labels[key]=Object.assign({},translation[key],mergedVariant);
      }
    });
  } else {
    labels=translation;
  }
  return labels;
}
*/

function translatedArea(area, languageTranslation) {
  let areaTranslation=languageTranslation!==undefined ? languageTranslation[area.name] : undefined;
  var labels=areaTranslation!==undefined
    ? updateLabels(area,areaTranslation)
    : area;

  if (languageTranslation.variant!==undefined) {
    labels=updateLabels(labels,languageTranslation.variant[area.name]);
  }
  return labels;
}

function mergeVariant(translation,variant) {
//  return Object.assign({},translation,variant);
  if (translation && typeof translation === 'object' && !Array.isArray(translation) && Object.keys(translation).length>0) {
    let outcome=Object.keys(translation)
      .map(key=>({
        key: key,
        value:variant!==undefined && variant[key]!==undefined
          ? typeof variant[key] ==="object"
            ? mergeVariant(translation[key],variant[key])
            : variant[key]
          : translation[key]
      }))
      .reduce((result,item)=>Object.assign({},result,{[item.key]:item.value}),{});
    return outcome;
  } else {
    return variant!==undefined ? variant : translation;
  }
}

class Translations {
  constructor(listOfTranslations) {
    this.translations=listOfTranslations!==undefined && listOfTranslations.length>0 ? listOfTranslations.reduce((translations,lang)=>Object.assign({},translations,lang)) : undefined;
  }

  loadVariants(listOfVariants) {
    this.variants=listOfVariants.reduce((translations,lang)=>Object.assign({},translations,lang));
    return this;
  }

  getFormLabels(formDefinition,language,variant) {
    return mergeVariant(
//      formDefinition,
      this.translations[language] || this.translations["english"],
      this.variants!==undefined ? this.variants[(language!==undefined ? language : "english")+"_"+variant] : undefined
    );
  }

  getTranslation(props,variant) {
    let language=props!==undefined && props.language!==undefined ? props.language : (typeof props)==="string" ? props : undefined;
    let languageVariant=props!==undefined && variant===undefined && props.variant!==undefined ? props.variant : variant;

    return mergeVariant(
      this.translations[language] || this.translations["english"],
      this.variants!==undefined ? this.variants[(language!==undefined ? language : "english")+"_"+languageVariant] : undefined
    );
  }

  createTranslatedForm(formDefinition,language,variant) {
    let labels=this.getFormLabels(formDefinition,language,variant);
    return formDefinition!==undefined ? formDefinition.map(area=>translatedArea(area,labels)) : undefined;
  }

  formatLabel(message) {
    let args = Array.prototype.slice.call(arguments, 1);
     return message.replace(/{(\d+)}/g, function(match, number) {
       return typeof args[number] != 'undefined'
         ? args[number]
         : match
       ;
     });
  }
}

module.exports=Translations



// WEBPACK FOOTER //
// ./app/utils/translations.js